import axios from '../axios';
import config from '../config';

export default {
    getImg(folderName, token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/images/${folderName}`,
            headers: { token }
        })
    }, uploadFile(file, newName, subject, token) {
  
        const formData = new FormData();
        formData.append('newName', newName);
        formData.append('file', file);
        formData.append('subject', subject);
        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: `/v1/business/${token}/banner/type/${subject}`,
            data: formData,
            headers: { token }
        })
    }, deleteFile(fileName, subject, token) {
        const formData = new FormData();
        formData.append('fileName', fileName);
        formData.append('subject', subject);
        return axios({
            method: 'delete',
            baseURL: config.apiUrls(),
            url: `/v1/business/${token}/banner/type/${subject}`,
            data: formData,
            headers: { token }
        })
    }, deleteImage(folderName, imageName, token) {

        return axios({
            method: 'post',
            baseURL: config.apiUrls(),
            url: `/v1/business/DeleteImage/${folderName}/${imageName}`,
            headers: { token }
        })
    }

}